export default {
  'component.tagSelect.expand': 'Expandir',
  'component.tagSelect.collapse': 'Recolher',
  'component.tagSelect.all': 'Todos',
  'component.themeToggle.switchToLight': 'Modo claro',
  'component.themeToggle.switchToDark': 'Modo escuro',
};
